import useStartCookingOnlineOrder from '@client/page/management/online-order/detail/logic/use-start-cooking-online-order.ts';
import { useCallback } from 'react';
import { useNotificationCenter } from '@packages/ui/notification/notification-center.ts';
import PrimaryButton from '@packages/ui/button/primary-button.tsx';
import { useTranslate } from '@tolgee/react';

const OnlineOrderActionStartCooking = (props: {
  orderID: string;
  preparingTime?: number | null;
  onClose?: () => void;
}) => {
  const { orderID, preparingTime, onClose } = props;

  const { showAlert } = useNotificationCenter();

  const [startCooking, { loading }] = useStartCookingOnlineOrder();
  const { t } = useTranslate();

  const startCookingHandler = useCallback(() => {
    if (preparingTime == null) {
      showAlert({
        status: 'error',
        title: t('alert.title.error', 'Error'),
        message: t(
          'online-order.start-cooking.alert.preparing-time-null.message',
          'You have not set preparing time, please select again.'
        ),
      });
      return;
    }
    startCooking({
      variables: {
        id: orderID,
        input: {
          preparingTime: preparingTime,
        },
      },
    })
      .then(() => {
        showAlert({
          status: 'success',
          title: t('alert.title.success'),
          message: t('online-order.detail.action.start-cooking.alert.message', 'Order cooking has started'),
        });
        onClose?.();
      })
      .catch((e: Error) => {
        showAlert({
          status: 'error',
          title: t('alert.title.error'),
          message: e.message,
        });
      });
  }, [startCooking, orderID, preparingTime, showAlert, onClose, t]);

  return (
    <PrimaryButton onClick={startCookingHandler} disabled={loading}>
      {t('online-order.detail.action.start-cooking.button', 'Start cooking')}
    </PrimaryButton>
  );
};

export default OnlineOrderActionStartCooking;
